export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1024w.3dcb41f2.avif";